import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FeaturesConfigModule, I18nModule, UrlModule } from "@spartacus/core";
import { OutletModule, MediaModule, AtMessageModule, IconModule, ItemCounterModule, ListNavigationModule, PageComponentModule, ProductListModule, SpinnerModule, StarRatingModule, ProductListItemContextSource, PageSlotModule, OutletRefModule } from "@spartacus/storefront";
import { RouterModule } from "@angular/router";
import { InfiniteScrollModule } from "ngx-infinite-scroll";
/* import { KbAddToCartModule } from "../../kb-add-to-cart/kb-add-to-cart.module"; */
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { KbDocumentListComponent } from "./kb-document-list.component";
import { MatDialogModule } from "@angular/material/dialog";
import { KbPipesModule } from "../../../../pipes/kb-pipes.module";


@NgModule({
    imports: [
        AtMessageModule,
        CommonModule,
        FeaturesConfigModule,
        I18nModule,
        IconModule,
        InfiniteScrollModule,
        ItemCounterModule,
        ListNavigationModule,
        MediaModule,
        OutletModule,
        PageComponentModule,
        OutletRefModule,
        PageSlotModule,
        RouterModule,
        SpinnerModule,
        StarRatingModule,
        UrlModule,
        ProductListModule,
        /*  KbAddToCartModule, */
        FormsModule,
        MatDialogModule,
        ReactiveFormsModule,
        KbPipesModule,
        KbDocumentListComponent,
    ],
    providers: [
        ProductListItemContextSource
    ],
    exports: [KbDocumentListComponent]
})
export class KbDocumentListItemModule {

}
